function cov_e9j8e6vob() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/NewTabFilled.tsx";
  var hash = "4b0ef6b595557d50809aaadadba01d23fb022370";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/NewTabFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 54
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4b0ef6b595557d50809aaadadba01d23fb022370"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_e9j8e6vob = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_e9j8e6vob();
var Icon = (cov_e9j8e6vob().s[0]++, {
  name: 'new-tab-filled',
  svg: "<path d=\"M21.9498 10.0267L22.0065 1.98876L13.1912 2.05015C12.5008 2.05495 11.9451 2.61848 11.9499 3.30882C11.9547 3.99916 12.5182 4.55489 13.2086 4.55009L17.4399 4.52062L10.116 11.8445C9.62784 12.3327 9.62784 13.1241 10.116 13.6123C10.6041 14.1004 11.3956 14.1004 11.8838 13.6123L19.478 6.01802L19.4499 10.009C19.445 10.6994 20.0007 11.263 20.6911 11.2678C21.3814 11.2727 21.945 10.717 21.9498 10.0267Z\" fill=\"currentColor\"/>\n  <path d=\"M3.69995 4.74999C2.73345 4.74999 1.94995 5.5335 1.94995 6.5V20.5C1.94995 21.4665 2.73345 22.25 3.69995 22.25H17.7C18.6665 22.25 19.45 21.4665 19.45 20.5V12.6035C19.45 11.2672 17.8342 10.5979 16.8893 11.5429L11.7303 16.7019C11.4374 16.9948 10.9625 16.9948 10.6696 16.7019L6.99805 13.0303C6.70516 12.7374 6.70516 12.2626 6.99805 11.9697L11.6571 7.31065C12.602 6.36571 11.9328 4.74999 10.5964 4.74999H3.69995Z\" fill=\"currentColor\"/>"
});
export default Icon;